<template>
  <div id="box">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <div v-if="isPage == 'index'" class="body">

        <div class="flex">
          <ul class="topBox">

            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入意见反馈"></el-input>
              </div>
            </li>

            <li class="flex" style="padding-top: 5px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>


            </li>
          </ul>

        </div>


        <!-- 主体内容 -->
        <div>
          <div class="table-scroll-wrap">
          <el-table :data="tableData" border style="width: 100%; margin-top: 10px" @row-click="clickData">

            <!-- <el-table-column prop="id" width="100" align="center" label="ID">
            </el-table-column> -->
            <el-table-column type="index" align="center" label="头像" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.user">
                  <img :src="scope.row.user.photo" style="width: 45px; height: 45px" alt="" srcset="" />
                </div>
              </template>
            </el-table-column>


            <el-table-column prop="nickname" align="center" label="昵称">
              <template slot-scope="scope">
                <div v-if="scope.row.user">
                 {{scope.row.user.nickName}}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="depict" align="center" label="意见反馈" min-width="160" show-overflow-tooltip>
            </el-table-column>

            <el-table-column label="截图" width="120" align="center">
              <template slot-scope="scope">
                <div v-if="parseOpinionImages(scope.row.images).length" class="fb-img-cell">
                  <el-image
                    v-for="(url, idx) in parseOpinionImages(scope.row.images).slice(0, 3)"
                    :key="'fb-list-img-' + scope.row.id + '-' + idx"
                    class="fb-list-thumb"
                    :src="url"
                    fit="cover"
                    :preview-src-list="parseOpinionImages(scope.row.images)"
                  />
                  <span
                    v-if="parseOpinionImages(scope.row.images).length > 3"
                    class="fb-img-more"
                  >+{{ parseOpinionImages(scope.row.images).length - 3 }}</span>
                </div>
                <span v-else class="fb-img-empty">—</span>
              </template>
            </el-table-column>

            <el-table-column prop="time" align="center" label="注册时间">
            </el-table-column>



          </el-table>
          </div>

          <list-pagination
            :total="tableTotal"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            @page-change="changePage"
            @size-change="handlePageSizeChange"
          />
        </div>
        <!-- 主体内容 -->
      </div>







    </div>
  </div>
</template>

<script>
import { delTips, returnTime } from "@/util/utils";


export default {
  components: {

  },
  data() {
    return {
      isPage: "index",

      dataList: {},

      surplusShow: 0,
      userList: "",

      // 历史记录
      historyArr: ["意见反馈"],

      //  搜索
      searchVle: "",



      // 数据信息
      tableData: [],
      pageSize: 50,
      currentPage: 1,
      tableTotal: 0,

      // 用户密码
      delShow: 0, //删除提示
      delList: {},
      userPass: "",
    };
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    parseOpinionImages(raw) {
      if (!raw || typeof raw !== "string") return [];
      const base = (this.$api.urls || "").replace(/\/$/, "");
      return raw
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((url) => {
          if (/^https?:\/\//i.test(url)) return url;
          return url.startsWith("/") ? base + url : `${base}/${url}`;
        });
    },
    // 搜索
    searchFn: function (res) {
      this.selListFn(1);
      this.currentPage = 1;
    },

    clickData() {

    },





    // 查询
    selListFn: function (page) {
      var obj = {
        page: page,
        size: this.pageSize,
      };



      if (this.searchVle) {
        obj.depict = this.searchVle;
      }

      this.$https(this.$api.api.selFeedback, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          data.forEach(v => {
            v.time = v.createTime ? returnTime(new Date(v.createTime),'-','s') : "";

          });
          this.tableData = data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.selListFn(this.currentPage);
      this.isPage = "index";
      this.historyArr.pop();
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    handlePageSizeChange() {
      this.selListFn(this.currentPage);
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];

      this.$https(
        this.$api.api.delFeedback,
        {

          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .body {
    margin-top: 20px;
  }

  .top_right {
    display: flex;
  }

  .topBox {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
    font-size: 15px;

    li {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;

      .el-range-editor.el-input__inner {
        width: 290px;
      }
    }

    li:last-child {
      margin-right: 0px;
    }

    span {
      margin-right: 5px;
    }
  }

  .fb-img-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .fb-list-thumb {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .fb-img-more {
    font-size: 12px;
    color: #909399;
  }

  .fb-img-empty {
    color: #c0c4cc;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/index.vue